import { Paginated } from "../../../../common/domain/models/paginated_models";
import { CentroCusto } from "../../domain/models/centro_custo";
import { CentroCustoLista } from "../../domain/models/centro_custo_lista";
import { IComercialRepository } from "../../domain/repositories/comercial_repositories";
import { IComercialService } from "../services/comercial_service";
import { ErrorsList } from '../../domain/models/erros_list';
import { InformacaoFaturamento } from "../../domain/models/informacao_faturamento";
import { Cliente } from '../../domain/models/cliente';
import { CentroCustoEndereco } from '../../domain/models/centro_custo_endereco';
import { ClienteLista } from '../../domain/models/clienteLista';
import { ClienteCentroCusto } from '../../domain/models/clienteCentroCusto';
import { ClienteCentroCustoLista } from '../../domain/models/clienteCentroCustoLista';
import { ClienteArquivo } from '../../domain/models/clienteArquivo';
import { ClienteArquivoLista } from '../../domain/models/clienteArquivoLista';
import { NovosNegocios } from '../../domain/models/novos_negocios';
import { NovosNegociosArquivoLista } from "../../domain/models/novos_negocios_arquivo_lista";
import { NovosNegociosLista } from "../../domain/models/novos_negocios_lista";
import { Subconta } from "../../domain/models/subconta";
import { SubcontaLista } from "../../domain/models/subconta_lista";
import { DashboardComercial } from "../../domain/models/dashboard_comercial";


export class ComercialRepository implements IComercialRepository {
    constructor(
        private readonly service: IComercialService,
    ) { }

    //#region  Centro de custo 
    async getAllCentroCustoLista(
        codigo: string,
        idsCentroCusto: number[],
        status: number,
        currentPage?: number,
        rowsPerPage?: number

    ): Promise<Paginated<CentroCustoLista>> {
        const response = await this.service.getAllCentroCustoLista({ codigo, idsCentroCusto, status, currentPage, rowsPerPage });
        return { ...response };
    };

    async getCentroCustoById(idCentroCusto: number): Promise<CentroCusto> {
        const response = await this.service.getCentroCustoById(idCentroCusto);
        return {
            idCentroCusto: response.idCentroCusto,
            status: response.status,
            codigo: response.codigo,
            descricao: response.descricao,
            bdi: response.bdi,
            bdi2: response.bdi2,
            numeroCno: response.numeroCno,
            obsCentrocusto: response.obsCentrocusto,
        }
    };

    async deleteCentroCustoById(idCentroCusto: number): Promise<ErrorsList> {

        const erros = await this.service.deleteCentroCustoById({ idCentroCusto });
        return { ...erros };

    }

    async createCentroCusto(
        status: number,
        codigo: string,
        descricao: string,
        bdi?: number | null,
        bdi2?: number | null,
        numeroCno?: string,
        obsCentroCusto?: string): Promise<CentroCusto> {
        const result = await this.service.createCentroCusto({
            status: status,
            codigo: codigo,
            descricao: descricao,
            bdi: bdi,
            bdi2: bdi2,
            numeroCno: numeroCno,
            obsCentroCusto: obsCentroCusto
        });
        return { ...result };
    }

    async updateCentroCusto(
        idCentroCusto: number,
        status: number,
        codigo: string,
        descricao: string,
        bdi?: number | null,
        bdi2?: number | null,
        numeroCno?: string,
        obsCentroCusto?: string): Promise<CentroCusto> {
        const result = await this.service.updateCentroCusto({
            idCentroCusto: idCentroCusto,
            status: status,
            codigo: codigo,
            descricao: descricao,
            bdi: bdi,
            bdi2: bdi2,
            numeroCno: numeroCno,
            obsCentroCusto: obsCentroCusto
        });
        return { ...result };
    }

    async createInformacaoFaturamento(formFaturamento: InformacaoFaturamento): Promise<InformacaoFaturamento> {
        const result = await this.service.createInformacaoFaturamento({
            idCentroCusto: formFaturamento.idCentroCusto,
            idEnderecoFaturamento: formFaturamento.idEnderecoFaturamento,
            idCliente: formFaturamento.idCliente,
            razaoSocial: formFaturamento.razaoSocial,
            nomeFantasia: formFaturamento.nomeFantasia,
            cnpj: formFaturamento.cnpj,
            cpf: formFaturamento.cpf,
            inscricaoEstadual: formFaturamento.inscricaoEstadual,
            inscricaoMunicipal: formFaturamento.inscricaoMunicipal,
            telefoneFixo: formFaturamento.telefoneFixo,
            telefoneCelular: formFaturamento.telefoneCelular,
            email: formFaturamento.email,
            contato: formFaturamento.contato,
            principal: formFaturamento.principal,
            //endereço
            rua: formFaturamento.rua,
            numero: formFaturamento.numero,
            apartamento: formFaturamento.apartamento,
            cep: formFaturamento.cep,
            uf: formFaturamento.uf,
            cidade: formFaturamento.cidade,
            bairro: formFaturamento.bairro,
            pais: formFaturamento.pais
        });

        return { ...result };
    }

    async updateInformacaoFaturamento(formFaturamento: InformacaoFaturamento): Promise<InformacaoFaturamento> {
        const result = await this.service.updateInformacaoFaturamento({
            idInformacaoFaturamento: formFaturamento.idInformacaoFaturamento,
            idCentroCusto: formFaturamento.idCentroCusto,
            idEnderecoFaturamento: formFaturamento.idEnderecoFaturamento,
            idCliente: formFaturamento.idCliente,
            razaoSocial: formFaturamento.razaoSocial,
            nomeFantasia: formFaturamento.nomeFantasia,
            cnpj: formFaturamento.cnpj,
            cpf: formFaturamento.cpf,
            inscricaoEstadual: formFaturamento.inscricaoEstadual,
            inscricaoMunicipal: formFaturamento.inscricaoMunicipal,
            telefoneFixo: formFaturamento.telefoneFixo,
            telefoneCelular: formFaturamento.telefoneCelular,
            email: formFaturamento.email,
            contato: formFaturamento.contato,
            principal: formFaturamento.principal,
            //endereço
            rua: formFaturamento.rua,
            numero: formFaturamento.numero,
            apartamento: formFaturamento.apartamento,
            cep: formFaturamento.cep,
            uf: formFaturamento.uf,
            cidade: formFaturamento.cidade,
            bairro: formFaturamento.bairro,
            pais: formFaturamento.pais

        });

        return { ...result };
    }

    async deleteInformacaoFaturamento(idInfFaturamento: number): Promise<void> {
        await this.service.deleteInformacaoFaturamento({ idInformacaoFaturamento: idInfFaturamento })

    }

    async getInformacaoFaturamento(idInfFaturamento: number): Promise<InformacaoFaturamento> {
        const result = await this.service.getInformacaoFaturamento({ idInformacaoFaturamento: idInfFaturamento })
        return { ...result }
    }

    async getInformacaoFaturamentoList(page: number, rowsPerPage: number, idCentroCusto: number): Promise<Paginated<InformacaoFaturamento>> {
        const result = await this.service.getInformacaoFaturamentoList({ currentPage: page, rowsPerPage, idCentroCusto })
        return { ...result }

    }

    async createCentroCustoEndereco(form: CentroCustoEndereco): Promise<CentroCustoEndereco> {
        const result = await this.service.createCentroCustoEndereco({
            idCentroCustoEndereco: form.idCentroCustoEndereco,
            idCentroCusto: form.idCentroCusto,
            tipoEndereco: form.tipoEndereco,

            //endereço
            rua: form.rua,
            numero: form.numero,
            apartamento: form.apartamento,
            cep: form.cep,
            uf: form.uf,
            cidade: form.cidade,
            bairro: form.bairro,
            pais: form.pais,
            principal: form.principal ? true : false
        });

        return { ...result };
    }

    async updateCentroCustoEndereco(form: CentroCustoEndereco): Promise<CentroCustoEndereco> {
        const result = await this.service.updateCentroCustoEndereco({
            idCentroCustoEndereco: form.idCentroCustoEndereco,
            idCentroCusto: form.idCentroCusto,
            idEndereco: form.idEndereco,
            tipoEndereco: form.tipoEndereco,

            //endereço
            rua: form.rua,
            numero: form.numero,
            apartamento: form.apartamento,
            cep: form.cep,
            uf: form.uf,
            cidade: form.cidade,
            bairro: form.bairro,
            pais: form.pais,

            principal: form.principal ? true : false
        });

        return { ...result, principal: result.principal ? 1 : 0 };
    }

    async deleteCentroCustoEndereco(idCentroCustoEndereco: number): Promise<void> {
        await this.service.deleteCentroCustoEndereco({ idCentroCustoEndereco })

    }

    async getCentroCustoEnderecoById(idCentroCustoEndereco: number): Promise<CentroCustoEndereco> {
        const result = await this.service.getCentroCustoEnderecoById({ idCentroCustoEndereco })
        return { ...result, principal: result.principal ? 1 : 0 }
    }

    async getAllCentroCustoEndereco(page: number, rowsPerPage: number, idCentroCusto: number): Promise<Paginated<CentroCustoEndereco>> {
        const result = await this.service.getAllCentroCustoEndereco({ currentPage: page, rowsPerPage, idCentroCusto })
        return {
            ...result, items: result.items
                .map((endereco) => ({ ...endereco, principal: endereco.principal ? 1 : 0 }))
        }

    }

    //#endregion 




    //#region Cliente

    async getClienteById(idCliente: number): Promise<Cliente> {
        const result = await this.service.getClienteById({ idCliente })
        return { ...result }
    }

    async getAllClienteLista(
        idsCentroCusto?: number[],
        nomeFantasia?: string,
        cnpj?: string,
        cpf?: string,
        unidade?: string,

        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<ClienteLista>> {
        const result = await this.service.getAllClienteLista({
            idsCentroCusto,
            nomeFantasia,
            cnpj,
            cpf,
            unidade,

            currentPage,
            rowsPerPage
        });
        return { ...result, };
    }


    async deleteClienteById(idCliente: number): Promise<void> {
        await this.service.deleteClienteById(idCliente);
    }

    async createCliente(form: Cliente): Promise<number> {
        const result = await this.service.createCliente({
            dataCadastro: form.dataCadastro,
            razaoSocial: form.razaoSocial,
            nomeFantasia: form.nomeFantasia,
            cnpj: form.cnpj,
            cpf: form.cpf,
            incricaoEstadual: form.incricaoEstadual,
            incricaoMunicipal: form.incricaoMunicipal,
            atividade: form.atividade,
            obsCliente: form.obsCliente,
            idEndereco: form.idEndereco,
            telefoneFixo: form.telefoneFixo,
            telefoneCelular: form.telefoneCelular,
            email: form.email,
            contato: form.contato,
            unidade: form.unidade,
            dataNascimento: form.dataNascimento,
            nomeFantasia2: form.nomeFantasia2,
            cpf2: form.cpf2,
            dataNascimento2: form.dataNascimento2,
            // endereco
            rua: form.rua,
            numero: form.numero,
            apartamento: form.apartamento,
            cep: form.cep,
            uf: form.uf,
            cidade: form.cidade,
            bairro: form.bairro,
            pais: form.pais,
        });

        return result.idCliente;

    }

    async updateCliente(form: Cliente): Promise<void> {
        await this.service.updateCliente({
            idCliente: form.idCliente,
            dataCadastro: form.dataCadastro,
            razaoSocial: form.razaoSocial,
            nomeFantasia: form.nomeFantasia,
            cnpj: form.cnpj,
            cpf: form.cpf,
            incricaoEstadual: form.incricaoEstadual,
            incricaoMunicipal: form.incricaoMunicipal,
            atividade: form.atividade,
            obsCliente: form.obsCliente,
            idEndereco: form.idEndereco,
            telefoneFixo: form.telefoneFixo,
            telefoneCelular: form.telefoneCelular,
            email: form.email,
            contato: form.contato,
            unidade: form.unidade,
            dataNascimento: form.dataNascimento,
            nomeFantasia2: form.nomeFantasia2,
            cpf2: form.cpf2,
            dataNascimento2: form.dataNascimento2,

            // endereco
            rua: form.rua,
            numero: form.numero,
            apartamento: form.apartamento,
            cep: form.cep,
            uf: form.uf,
            cidade: form.cidade,
            bairro: form.bairro,
            pais: form.pais,

        });
    }
    //#endregion

    //#region Cliente Centro Custo
    async getClienteCentroCustoById(idClienteCentroCusto: number): Promise<ClienteCentroCusto> {
        const result = await this.service.getClienteCentroCustoById({ idClienteCentroCusto });
        return {
            ...result,
            principal: result.principal ? 1 : 0
        };
    }

    async getAllClienteCentroCustoLista(
        idCliente: number,

        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<ClienteCentroCustoLista>> {
        const result = await this.service.getAllClienteCentroCustoLista({ idCliente, currentPage, rowsPerPage });
        return { ...result };
    }

    async deleteClienteCentroCustoById(idClienteCentroCusto: number): Promise<void> {
        await this.service.deleteClienteCentroCustoById(idClienteCentroCusto);
    }

    async createClienteCentroCusto(form: ClienteCentroCusto): Promise<number> {
        const result = await this.service.createClienteCentroCusto({
            idCliente: form.idCliente,
            idCentroCusto: form.idCentroCusto,
            unidade: form.unidade,
            principal: form.principal === 1 ? true : false,
        });

        return result.idClienteCentroCusto;
    }

    async updateClienteCentroCusto(form: ClienteCentroCusto): Promise<void> {
        await this.service.updateClienteCentroCusto({
            idClienteCentroCusto: form.idClienteCentroCusto,
            idCliente: form.idCliente,
            idCentroCusto: form.idCentroCusto,
            unidade: form.unidade,
            principal: form.principal === 1 ? true : false,

        });

    }

    //#endregion

    //#region Cliente Arquivo
    async getClienteArquivoById(idClienteArquivo: number): Promise<ClienteArquivo> {
        const result = await this.service.getClienteArquivoById({ idClienteArquivo });
        return { ...result };
    }

    async getAllClienteArquivoLista(
        idCliente: number,
        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<ClienteArquivoLista>> {
        const result = await this.service.getAllClienteArquivoLista({ idCliente, currentPage, rowsPerPage });
        return { ...result };
    }

    async deleteClienteArquivoById(idClienteArquivo: number): Promise<void> {
        await this.service.deleteClienteArquivoById(idClienteArquivo);
    }

    async createClienteArquivo(
        idCliente?: number,
        nomeArquivo?: string,
        descricao?: string,
        arquivo?: File,
    ): Promise<number> {
        const result = await this.service.createClienteArquivo({
            idCliente: idCliente,
            descricao: descricao,
            arquivo: arquivo,
            nome: nomeArquivo,
        });
        return result.idClienteArquivo;
    }

    async updateClienteArquivo(idClienteArquivo: number,
        idCliente?: number,
        nomeArquivo?: string,
        descricao?: string,
        arquivo?: File,
        limparArquivo?: boolean): Promise<void> {

        await this.service.updateClienteArquivo({
            idClienteArquivo: idClienteArquivo,
            idCliente: idCliente,
            descricao: descricao,
            arquivo: arquivo,
            nome: nomeArquivo,
            limparArquivo: limparArquivo ?? false

        });
    }

    async downloadClienteArquivoS3(idClienteArquivo: number): Promise<Blob> {
        const result = await this.service.downloadClienteArquivoS3({ id: idClienteArquivo });
        return result;

    }

    //#endregion


    //#region Novos Negócios

    async getNovosNegociosById(idNovosNegocios: number): Promise<NovosNegocios> {
        const result = await this.service.getNovosNegociosById({ idNovosNegocios });
        return { ...result };
    }

    async getAllNovosNegociosLista(
        idsCliente: number[],
        cidade?: string,
        data?: Date,
        status?: number,

        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<NovosNegociosLista>> {
        const result = await this.service.getAllNovosNegociosLista({
            idsCliente,
            cidade,
            data,
            status,

            currentPage,
            rowsPerPage
        });
        return { ...result };
    }

    async deleteNovosNegociosById(idNovosNegocios: number): Promise<void> {
        await this.service.deleteNovosNegociosById(idNovosNegocios);

    }

    async createNovosNegocios(form: NovosNegocios): Promise<number> {
        const result = await this.service.createNovosNegocios({
            nrNegocio: form.nrNegocio,
            titulo: form.titulo,
            idCliente: form.idCliente,
            idCentroCusto: form.idCentroCusto,
            nProposta: form.nProposta,
            nEdital: form.nEdital,
            dadosCliente: form.dadosCliente,
            possivelEscopo: form.possivelEscopo,
            viavelFinanc: form.viavelFinanc,
            possivelPrazos: form.possivelPrazos,
            possivelReqLegais: form.possivelReqLegais,
            comentarios: form.comentarios,
            situacaoProposta: form.situacaoProposta,
            statusParticipar: form.statusParticipar,
            outros: form.outros,
            observacao: form.observacao,
            dataCriacao: form.dataCriacao,
            arquivo: form.arquivo,
            nomeArquivo: form.nomeArquivo,
            data: form.data,
            cidade: form.cidade,
            idFuncionario: form.idFuncionario,
            dataSituacao: form.dataSituacao,
            telefone: form.telefone,

        });

        return result.idNovosNegocios;
    }

    async updateNovosNegocios(form: NovosNegocios): Promise<void> {
        await this.service.updateNovosNegocios({
            idNovosNegocios: form.idNovosNegocios,
            nrNegocio: form.nrNegocio,
            titulo: form.titulo,
            idCliente: form.idCliente,
            idCentroCusto: form.idCentroCusto,
            nProposta: form.nProposta,
            nEdital: form.nEdital,
            dadosCliente: form.dadosCliente,
            possivelEscopo: form.possivelEscopo,
            viavelFinanc: form.viavelFinanc,
            possivelPrazos: form.possivelPrazos,
            possivelReqLegais: form.possivelReqLegais,
            comentarios: form.comentarios,
            situacaoProposta: form.situacaoProposta,
            statusParticipar: form.statusParticipar,
            outros: form.outros,
            observacao: form.observacao,
            dataCriacao: form.dataCriacao,
            arquivo: form.arquivo,
            nomeArquivo: form.nomeArquivo,
            data: form.data,
            cidade: form.cidade,
            idFuncionario: form.idFuncionario,
            dataSituacao: form.dataSituacao,
            telefone: form.telefone,

            limparArquivo: form.limparArquivo ?? false,
        });
    }


    async sendEmailNovosNegocios(
        idNovosNegocios: number,
        subject: string,
        emails: string[],
        body: string,
        attachment: string,
    ): Promise<void> {
        await this.service.sendEmailNovosNegocios({
            idNovosNegocios,
            subject,
            emails,
            body,
            attachment,
        });
    }

    //#endregion

    //#region Novos Negócios Arquivo
    async getNovosNegociosArquivoById(idNovosNegociosArquivo: number): Promise<Blob> {
        const result = await this.service.getNovosNegociosArquivoById({ idNovosNegociosArquivo });
        return result;
    }

    async getAllNovosNegociosArquivoLista(
        idNovosNegocios: number,

        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<NovosNegociosArquivoLista>> {
        const result = await this.service.getAllNovosNegociosArquivoLista({ idNovosNegocios, currentPage, rowsPerPage });
        return { ...result };
    }

    async deleteNovosNegociosArquivoById(idNovosNegociosArquivo: number): Promise<void> {
        await this.service.deleteNovosNegociosArquivoById(idNovosNegociosArquivo);
    }

    async createNovosNegociosArquivo(
        idNovosNegocios?: number,
        nomeArquivo?: string,
        descricao?: string,
        arquivo?: File,
    ): Promise<number> {
        const result = await this.service.createNovosNegociosArquivo({
            idNovosNegocios: idNovosNegocios,
            descricao: descricao,
            arquivo: arquivo,
            nome: nomeArquivo,
        });
        return result.idNovosNegociosArquivo;
    }

    async updateNovosNegociosArquivo(
        idNovosNegociosArquivo: number,
        idNovosNegocios?: number,
        nomeArquivo?: string,
        descricao?: string,
        arquivo?: File,

        limparArquivo?: boolean
    ): Promise<void> {
        await this.service.updateNovosNegociosArquivo({
            idNovosNegociosArquivo: idNovosNegociosArquivo,
            idNovosNegocios: idNovosNegocios,
            descricao: descricao,
            arquivo: arquivo,
            nome: nomeArquivo,

            limparArquivo: limparArquivo ?? false,
        });
    }

    async downloadNovosNegociosArquivo(
        idNovosNegocios: number
    ): Promise<string | null> {
        const response = await this.service.downloadNovosNegociosArquivo({ idNovosNegocios });
        return response.item;
    }

    //#endregion


    //#region Subcontas
    async getSubcontaById(idSubconta: number): Promise<Subconta> {
        const result = await this.service.getSubcontaById({ idSubconta });
        return {
            ...result,
            codigo: result.codigo ?? '-',
            descricao: result.descricao ?? '-'
        };
    }

    async getAllSubcontas(
        codigo?: string,
        descricao?: string,
        status?: number,

        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<SubcontaLista>> {
        const result = await this.service.getAllSubcontas({ codigo, descricao, status, currentPage, rowsPerPage });
        return { ...result };
    }

    async deleteSubcontaById(idSubconta: number): Promise<void> {
        await this.service.deleteSubcontaById(idSubconta);
    }

    async createSubconta(
        ativo: boolean,
        idSubcontaPai?: number,
        codigo?: string,
        descricao?: string,
    ): Promise<number> {
        const result = await this.service.createSubconta({
            ativo: ativo,
            idSubcontaPai: idSubcontaPai,
            codigo: codigo,
            descricao: descricao,
        });
        return result.idSubconta;
    }

    async updateSubconta(
        idSubconta: number,
        ativo: boolean,
        idSubcontaPai?: number,
        codigo?: string,
        descricao?: string,
    ): Promise<void> {
        await this.service.updateSubconta({
            idSubconta: idSubconta,
            ativo: ativo,
            idSubcontaPai: idSubcontaPai,
            codigo: codigo,
            descricao: descricao,
        });
    }

    //#endregion



    async getDashboardComercialInformation(
    ): Promise<DashboardComercial> {
        const response = await this.service.getDashboardComercialInformation({});
        return response.item;
    }
}
